import { render, staticRenderFns } from "./RedirectToHome.vue?vue&type=template&id=00b126bf&"
import script from "./RedirectToHome.vue?vue&type=script&lang=ts&"
export * from "./RedirectToHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports